import { useMutation } from "@tanstack/react-query"
import { useCmApi } from "@/shared/hooks/useCmApi"

export const useGetAiDescription = (customerId: string) => {
  const cmApi = useCmApi()
  const {
    mutate: generateDescription,
    isPending,
    isError,
    error,
    data
  } = useMutation<string>({
    mutationFn: () => cmApi.getAiDescription(customerId)
  })

  return {
    generateDescription,
    isLoading: isPending,
    isError,
    error,
    data
  }
}
